export const FORMATS = {
	SHORT_DATE: 'YYYY-MM-DD',
	SLASH_DATE: 'M/D/YYYY'
};
